module.exports = __webpack_public_path__ + "img/couples-076.1ec693f7.jpg";